import { FC } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { getAppDataByUUID } from 'services/api/app';
import { useGetUserDataByUsername } from 'services/queries/app';

const PageNotFound: FC = () => {
  const { username } = useParams();
  const userData = useGetUserDataByUsername();
  const uuid = userData?.data?.id;
  const useGetAppDataByUUID = () => {
    return useQuery(['getAppDataByUUID', { uuid }], async () => {
      return await getAppDataByUUID(uuid);
    });
  };
  const appData = useGetAppDataByUUID();
  const homepage =
    appData?.data?.data?.domains?.length >= 1
      ? appData?.data?.data?.domains[0]
      : `${String(process.env.REACT_APP_REDIRECT_URI)}/${String(username)}`;

  return (
    <div className="min-h-screen flex flex-col justify-center items-center text-lg">
      <HelmetProvider>
        <Helmet>
          <meta name="errorpage" content="true" />
          <meta name="errortype" content="404 - Not Found" />
          <meta name="prerender-status-code" content="404" />
        </Helmet>
      </HelmetProvider>
      <h1 className="text-white">404 - Page Not Found</h1>
      <h2 className="m-0 bold text-[#5E5E5E]">OOPS, PAGE NOT FOUND.</h2>
      <p className="mb-0 text-[#5E5E5E]">
        Click&nbsp;
        <a href={homepage} className="text-blue-500">
          here
        </a>
        &nbsp;to go back to home page.
      </p>
    </div>
  );
};

export default PageNotFound;
